import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';
import { ManagerNameCellRenderer } from '~/components/vender';

import type { TypeOwnerSupplierManager } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 공급사 등록 모달 > '담당자 정보' 테이블
 */
const getVenderSupplierRegisterManagerInfoColumnDefs = ({
  onClickViewDetail,
}: {
  onClickViewDetail: (data: TypeOwnerSupplierManager, rowIndex: number) => void;
}) => {
  const columnDefs: TypeTableColumn<TypeOwnerSupplierManager>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'ownerSupplierManagerName',
      header: '담당자명',
      size: 120,
      cell: ({ getValue, row }) => <ManagerNameCellRenderer value={getValue<string>()} rowIndex={row.index} />,
    },
    {
      accessorKey: 'ownerSupplierManagerPosition',
      header: '직위',
      size: 120,
    },
    {
      accessorKey: 'ownerSupplierManagerTel',
      header: '휴대폰번호',
      size: 140,
    },
    {
      accessorKey: 'ownerSupplierManagerEmail',
      header: '이메일',
      size: 360,
    },
    {
      id: 'modify',
      header: '',
      cell: ({ row }) => (
        <TextButtonCell showDashIfNoValue={false} onClick={() => onClickViewDetail(row.original, row.index)}>
          수정
        </TextButtonCell>
      ),
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getVenderSupplierRegisterManagerInfoColumnDefs;
